import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function SkillsIcon({ className }: IconProps) {
  return (
    <svg
      width="123"
      height="77"
      viewBox="0 0 123 77"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1203_1433)">
        <path
          d="M74.029 72.1906C72.3601 59.5389 64.2777 48.9011 53.1197 43.5703C48.5182 46.674 42.9869 48.4983 37.0026 48.4983C31.0183 48.4983 25.487 46.674 20.9094 43.5703C9.77525 48.8774 1.69287 59.5152 0.0477792 72.1906C-0.286006 74.7494 1.74055 77.0238 4.33931 77.0238H69.7613C72.3601 77.0238 74.3866 74.7494 74.0528 72.1906H74.029Z"
          fill="#00416B"
        />
        <path
          d="M57.1247 19.9726C57.1247 30.9895 48.1363 39.9452 37.026 39.9452C25.9157 39.9452 16.9512 30.9895 16.9512 19.9726C16.9512 8.95569 25.9395 0 37.026 0C48.1124 0 57.1247 8.95569 57.1247 19.9726Z"
          fill="#00416B"
        />
        <path
          d="M118.566 0H82.1592C79.71 0 77.7246 1.97298 77.7246 4.40677V15.5658C77.7246 17.9996 79.71 19.9726 82.1592 19.9726H118.566C121.015 19.9726 123 17.9996 123 15.5658V4.40677C123 1.97298 121.015 0 118.566 0Z"
          fill="#EAEDF8"
        />
        <path
          d="M97.3462 2.32178H83.1127C81.6379 2.32178 80.4424 3.50981 80.4424 4.97532V14.9972C80.4424 16.4627 81.6379 17.6507 83.1127 17.6507H97.3462C98.821 17.6507 100.017 16.4627 100.017 14.9972V4.97532C100.017 3.50981 98.821 2.32178 97.3462 2.32178Z"
          fill="#00C4B3"
        />
        <path
          d="M118.566 57.0513H82.1592C79.71 57.0513 77.7246 59.0242 77.7246 61.458V72.6171C77.7246 75.0509 79.71 77.0239 82.1592 77.0239H118.566C121.015 77.0239 123 75.0509 123 72.6171V61.458C123 59.0242 121.015 57.0513 118.566 57.0513Z"
          fill="#EAEDF8"
        />
        <path
          d="M118.566 28.5254H82.1592C79.71 28.5254 77.7246 30.4984 77.7246 32.9322V44.0912C77.7246 46.525 79.71 48.498 82.1592 48.498H118.566C121.015 48.498 123 46.525 123 44.0912V32.9322C123 30.4984 121.015 28.5254 118.566 28.5254Z"
          fill="#EAEDF8"
        />
        <path
          d="M109.339 59.894H83.1606C81.8438 59.894 80.7764 60.9548 80.7764 62.2633V71.7876C80.7764 73.0961 81.8438 74.1568 83.1606 74.1568H109.339C110.656 74.1568 111.723 73.0961 111.723 71.7876V62.2633C111.723 60.9548 110.656 59.894 109.339 59.894Z"
          fill="#00C4B3"
        />
        <path
          d="M117.564 31.3213H83.1129C81.8225 31.3213 80.7764 32.3608 80.7764 33.6431V43.357C80.7764 44.6393 81.8225 45.6788 83.1129 45.6788H117.564C118.855 45.6788 119.901 44.6393 119.901 43.357V33.6431C119.901 32.3608 118.855 31.3213 117.564 31.3213Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_1203_1433">
          <rect width="123" height="77" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
